import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';
import { ChangeATMPINStackRoutes, ChangeATMPINStackScreenProps } from './type';
import { ChangeATMPINWebTwoScreen } from './ChangeATMPINWebTwo.screen';
import { ChangeATMPINNativeTwoScreen } from './ChangeATMPINNativeTwo.screen';

export interface ChangeATMPINProps {}
export const ChangeATMPINPlaced: React.FC<ChangeATMPINStackScreenProps<ChangeATMPINStackRoutes.Placed>> = ({ navigation, route }) => {
  const { onLayout, data, account, tab, returnData } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return <ChangeATMPINNativeTwoScreen onClose={onGoBack} data={data} account={account} tab={tab} returnData={returnData} />;
  }

  return (
    <ChangeATMPINWebTwoScreen onClose={closeModal} onLayout={onLayout} data={data} account={account} tab={tab} returnData={returnData} />
  );
};
